function maybeParseJson(value: unknown): unknown {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export function extractWorkflowResumeArgs(payload: unknown): { workflowId?: string } {
  const normalized = maybeParseJson(payload) as
    | { workflowId?: unknown; args?: unknown; value?: unknown }
    | null
    | undefined;

  const candidates = [
    normalized,
    normalized?.args,
    normalized?.value,
    (normalized?.args as { value?: unknown } | undefined)?.value,
  ].map(maybeParseJson);

  for (const candidate of candidates) {
    if (!candidate || typeof candidate !== "object") continue;
    const workflowId = (candidate as { workflowId?: unknown }).workflowId;
    if (typeof workflowId === "string" && workflowId.length > 0) {
      return { workflowId };
    }
  }

  return {};
}

export function getWorkflowResumeDeliveryJobId(workflowId: string): string {
  return `workflow:v2:${workflowId}`;
}
